import { useMutation } from "react-query";
import { updateDealer } from "../requests/updateDealer";

export default function useUpdateDealer() {
  return useMutation({
    mutationFn: ({ dealerId, data }: { dealerId: string; data: any }) =>
      updateDealer(dealerId, data),
  });
}
